class encAccordion extends HTMLElement {
  constructor() {
    super();
    this.onSummaryClick = this.onSummaryClick.bind(this); // keep correct "this"
  }

  connectedCallback() {
    this.summary = this.querySelector("summary");
    this.content = this.querySelector("content");

    if (!this.summary || !this.content) return;

    // Initialize height on load
    const isOpen = this.hasAttribute("open");
    this.content.style.maxHeight = isOpen ? this.content.scrollHeight + "px" : "0";

    // Dispatch event on page load
    this.dispatchEvent(new CustomEvent("encAccordionToggle", {
      detail: { open: isOpen, element: this },
      bubbles: true
    }));

    // Add click listener
    this.summary.addEventListener("click", this.onSummaryClick);
  }

  disconnectedCallback() {
    // Remove click listener when element is removed from DOM
    if (this.summary) this.summary.removeEventListener("click", this.onSummaryClick);
  }

  onSummaryClick() {
    const isCurrentlyOpen = this.hasAttribute("open");
    const groupName = this.getAttribute("closeGroup");

    if (groupName) {
      // Close other accordions in the same group
      document.querySelectorAll(`enc-accordion[closeGroup="${groupName}"]`).forEach(acc => {
        if (acc !== this) {
          acc.removeAttribute("open");
          const accContent = acc.querySelector("content");
          if (accContent) accContent.style.maxHeight = "0";
        }
      });
    }

    if (isCurrentlyOpen) {
      // Slide up current
      this.content.style.maxHeight = "0";
      this.removeAttribute("open");
      this.dispatchEvent(new CustomEvent("encAccordionToggle", {
        detail: { open: false, element: this },
        bubbles: true
      }));
    } else {
      // Slide down current
      this.content.style.maxHeight = this.content.scrollHeight + "px";
      this.setAttribute("open", "");
      this.dispatchEvent(new CustomEvent("encAccordionToggle", {
        detail: { open: true, element: this },
        bubbles: true
      }));
    }
  }
}

customElements.define("enc-accordion", encAccordion);